import { observable } from 'mobx';
import { ZERO } from '../../utils/constant';

class PanoramaMobx {
	@observable scene = '';   // 场景
	@observable camera = '';  // 相机
	@observable renderer = '';  // 渲染器
	@observable width = ZERO;   // 容器宽度
	@observable height = ZERO;   // 容器高度
	@observable fov = 75;  // 相机可视角度
	@observable aspect = ZERO;  // 容器宽高比
	@observable near = 0.1;   // 相机近端距离
	@observable far = 100;  //相机远端距离
	@observable containerNode = '';   // 容器节点，为了插入webgl
	@observable panoramaImgs = [];  // 全景图图片
	@observable isUserInteracting = false;  // 是不是用户触发的
	@observable startX = 0;
	@observable startY = 0;
	@observable endX = 0;
	@observable endY = 0;
	@observable lon = 0;
	@observable lat = 0;
	@observable phi = 0;
	@observable theta = 0;
	@observable onPointerDownLon = 0;
	@observable onPointerDownLat = 0;
	@observable startTime = 0;
	@observable lastDistance = 0;
	@observable deceleration = 0.1;
	@observable speed = { lat: 0, lon: 0 };
	@observable showLoading = true;   // 图片没加载完成的时候，显示loading
	@observable panoramaImgs = [];  // 全景图图片
	@observable lables = [];  // 标签列表
	@observable progressValue = 0;   // 进度条数值
	@observable targetRotation = 0;  // 角度

	@observable _cameraOrtho = '';
	@observable _sceneOrtho = '';

}
export default PanoramaMobx;